module.exports = __webpack_public_path__ + "static/img/logo.4816ca68.png";